import { type Icon, Yelp } from 'react-bootstrap-icons';

export interface IconTitleProps {
  title: string;
  subtitle?: string;
  icon?: Icon;
  iconColor?: string;
  iconClassName?: string;
  titleClassName?: string;
}

const IconTitle = ({
  title,
  subtitle,
  icon: IconComponent = Yelp,
  iconColor,
  iconClassName,
  titleClassName = 'text-primary'
}: IconTitleProps) => {
  return (
    <div className="d-flex align-items-start gap-4 mt-0 mb-3">
      {IconComponent && (
        <div className="pt-1">
          <IconComponent
            size={35}
            className={iconClassName || undefined}
            style={{
              ...(iconColor != null && { color: iconColor })
            }}
          />
        </div>
      )}
      <div>
        <div className={`fw-bolder ${titleClassName || ''}`}>{title}</div>
        <div className="text-dark">{subtitle} </div>
      </div>
    </div>
  );
};

export { IconTitle };
